const BASE = process.env.REACT_APP_BACKEND_URL;

let csrfToken = '';

export function setCsrfToken(token) {
  csrfToken = token;
}

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

export async function api(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (!(options.body instanceof FormData) && options.body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }
  if (options.method && options.method !== 'GET') {
    headers['X-CSRF-Token'] = csrfToken;
  }
  const res = await fetch(`${BASE}/api${path}`, {
    credentials: 'same-origin',
    ...options,
    headers,
  });
  if (res.status === 401 && !path.startsWith('/auth/')) {
    window.location.assign('/admin');
    throw new ApiError(401, 'Nicht angemeldet');
  }
  if (!res.ok) {
    let message = `Fehler ${res.status}`;
    try {
      const data = await res.json();
      if (typeof data.detail === 'string') message = data.detail;
      else if (Array.isArray(data.detail)) message = data.detail.map((d) => d.msg).join(', ');
    } catch { /* keep default */ }
    throw new ApiError(res.status, message);
  }
  if (res.status === 204) return null;
  return res.json();
}
